import React, { Component } from "react";
import Desplegable from "../../desplegable";
import VistaDatosTestamento from "../vistas/vista_testamento";
import FormDatosTestamento from "../formularios/form_testamento";

export default class DesplegableTestamento extends Component {
  render() {
    return (
      <Desplegable
        eventKey="9"
        id="9"
        Toogle={"Testamento y administración de bienes"}
        showModal={this.props.state.showModalMatrix[9]}
        handleButtonShow={this.props.handleButtonShow}
        Text={<VistaDatosTestamento DatosMonja={this.props.state.DatosUsuario}></VistaDatosTestamento>}
        Form={
          <FormDatosTestamento
            DatosMonja={this.props.state.DatosUsuario}
            ErrorHandling={this.props.propsErrorHandling}
            setDatosTestamento={this.props.setDatosTestamento}
            handleButtonShow={this.props.handleButtonShow}
            nullField={this.props.nullField}
            setAlert={this.props.setAlert}
          ></FormDatosTestamento>
        }
        canEdit={this.props.esAdmin}
      />
    );
  }
}
